module.exports = __webpack_public_path__ + "static/media/github.4e2208ae.gif";